import { render, staticRenderFns } from "./authorizationSwitch.vue?vue&type=template&id=ae7fb8e4&scoped=true&"
import script from "./authorizationSwitch.vue?vue&type=script&lang=js&"
export * from "./authorizationSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7fb8e4",
  null
  
)

export default component.exports